const CUTOFF_HOUR = 14;
const CUTOFF_MINUTE = 0;
const BANK_HOLIDAYS_API = 'https://www.gov.uk/bank-holidays.json';

let UK_HOLIDAYS_MAP = {};
const DIVISION = 'england-and-wales';
const DELIVERY_CUTOFF = new Date();
DELIVERY_CUTOFF.setHours(CUTOFF_HOUR, CUTOFF_MINUTE, 0, 0); 

const formatDate = (date) => {
    const dayName = date.toLocaleDateString('en-GB', { weekday: 'long' });
    const dayNum = date.getDate();
    const month = date.toLocaleDateString('en-GB', { month: 'short' });
    
    const suffix = ["th", "st", "nd", "rd"][
    (dayNum % 100 > 10 && dayNum % 100 < 20) 
        ? 0 
        : (dayNum % 10 < 4) ? (dayNum % 10) : 0
    ];

    return `${dayNum}${suffix} ${month} on ${dayName}`;
};

const formatDateHoliday = (date) => {
    const options = { weekday: 'long', day: 'numeric', month: 'long' };
    return date.toLocaleDateString('en-GB', options); 
};

const formatDateNumeric = (date) => {
    const options = { day: 'numeric', month: 'long' };
    return date.toLocaleDateString('en-GB', options); 
};

const isWeekend = (date) => {
    const day = date.getDay();
    return day === 6 || day === 0;
};

const getHolidayTitle = (date) => {
    const dateString = date.toISOString().split('T')[0];
    return UK_HOLIDAYS_MAP[dateString] || null;
};

const getCurrentOrTestDate = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const testDate = urlParams.get('date');
    
    if (testDate) {
        if (testDate.includes('T') || testDate.includes(':')) {
            return new Date(testDate);
        }
        return new Date(`${testDate} 12:00:00`); 
    }
    return new Date();
};

const calculateDeliveryDate = (currentDate, delay = 0, deliveryFloor = null) => {
    let deliveryDate = new Date(currentDate);
    let rawDelayDates = [];

    const isAfterCutoff = currentDate.getTime() >= DELIVERY_CUTOFF.getTime();

    if (isAfterCutoff) {
        deliveryDate.setDate(deliveryDate.getDate() + 2);
    } else {
        deliveryDate.setDate(deliveryDate.getDate() + 1);
    }

    if ( delay > 0 ) {
        deliveryDate.setDate(deliveryDate.getDate() + parseInt(delay));
    }

    if (deliveryFloor && deliveryFloor.getTime() > deliveryDate.getTime()) {
        deliveryDate = new Date(deliveryFloor);
    }

    let safetyCounter = 0;
    let weekendStartDate = null; 

    while (safetyCounter < 10) { 
        const isDOWeekend = isWeekend(deliveryDate);
        const holidayTitle = getHolidayTitle(deliveryDate);

        if (isDOWeekend) {
            if (!weekendStartDate) {
                weekendStartDate = new Date(deliveryDate);
            }
        } else {
            if (weekendStartDate) {
                const weekendEndDate = new Date(deliveryDate);
                weekendEndDate.setDate(weekendEndDate.getDate() - 1); 

                rawDelayDates.push({
                    type: 'Weekend',
                    start: weekendStartDate,
                    end: weekendEndDate 
                });
                weekendStartDate = null;
            }
            
            if (holidayTitle) {
                 rawDelayDates.push({
                    type: 'Holiday',
                    start: new Date(deliveryDate),
                    title: holidayTitle 
                });
            } else {
                break;
            }
        }
        
        deliveryDate.setDate(deliveryDate.getDate() + 1); 
        safetyCounter++;
    }
    
    const delayReasons = rawDelayDates.map(item => {
        if (item.type === 'Weekend') {
            return `${formatDateNumeric(item.start)} - ${formatDateNumeric(item.end)}: Weekend`;
        } else if (item.type === 'Holiday') {
            return `${formatDateHoliday(item.start)}: ${item.title} (Bank Holiday)`;
        }
    });

    return {
        date: deliveryDate,
        reasons: delayReasons
    };
};

const updateDeliveryInfo = () => {
    const infoElement = document.getElementById('delivery-info');
    const reasonElement = document.getElementById('delay-reason');
    const deliveryBox = document.querySelector('.delivery-box');
    
    if (!deliveryBox) return; 

    const delay = deliveryBox.getAttribute('data-delay') || 0;

    const deliveryDateAttr = deliveryBox.getAttribute('data-delivery-date');
    let deliveryFloor = null;
    if (deliveryDateAttr) {
        const parsedFloor = new Date(`${deliveryDateAttr} 12:00:00`);
        if (!isNaN(parsedFloor.getTime())) {
            deliveryFloor = parsedFloor;
        }
    }

    const price = parseFloat(deliveryBox.getAttribute('data-price')) || 0;
    const isFree = price > 50000000000000;
    
    const deliveryTextCap = isFree ? '<span class="free"> Delivery</span>' : 'Delivery';
    const deliveryTextLow = isFree ? '<span class="free">delivery</span>' : 'delivery';

    const isTwoManDelivery = deliveryBox && (
        deliveryBox.hasAttribute('data-twoman') || 
        deliveryBox.getAttribute('data-shipping-method') === 'shippingMethod_Two-Man Courier'
    );

    const isTestMode = new URLSearchParams(window.location.search).has('date');

    if (Object.keys(UK_HOLIDAYS_MAP).length === 0) {
         infoElement.innerHTML = "<p>Loading holiday data...</p>";
         setTimeout(updateDeliveryInfo, 500);
         return;
    }
    
    const now = getCurrentOrTestDate();
    const isFriday = now.getDay() === 5; 
    
    const result = calculateDeliveryDate(now, delay, deliveryFloor);
    const deliveryDateFormatted = formatDate(result.date);
    
    const cutoffTimeToday = new Date(now);
    cutoffTimeToday.setHours(CUTOFF_HOUR, CUTOFF_MINUTE, 0, 0);
    const timeRemainingMs = cutoffTimeToday.getTime() - now.getTime();
    
    let infoHTML = '';
    let upsellHTML = '';

    const minutesRemaining = Math.floor(timeRemainingMs / (1000 * 60));
    const hours = Math.floor(minutesRemaining / 60);
    const minutes = minutesRemaining % 60;
    const formattedMinutes = minutes.toString().padStart(2, '0');
    
    let timerText = '';
    if (timeRemainingMs > 0) {
        timerText = hours > 0 
            ? `${hours} hrs ${formattedMinutes} mins`
            : `${minutes} mins`;
    }

    if (isTwoManDelivery) {
        if (isFriday) {
             infoHTML = `Order Now - Get it as soon <strong>${deliveryDateFormatted}</strong>`;
        } else {
             infoHTML = `Earliest available ${deliveryTextLow} date is <strong>${deliveryDateFormatted}</strong>.`;
        }
        
        if (!isTestMode) setTimeout(updateDeliveryInfo, 60000); 

    } else {
        if (timeRemainingMs > 0) {
            if (isFriday) {
                infoHTML = `Order in the next <span>${timerText}</span> to get it on <strong>${deliveryDateFormatted}</strong>`;
            } else {
                infoHTML = `Earliest available ${deliveryTextLow} date is <strong>${deliveryDateFormatted}</strong>.`;
            }

            if (!isTestMode) {
                 const timeToNextMinute = 60000 - (now.getTime() % 60000);
                 setTimeout(updateDeliveryInfo, timeToNextMinute);
            }
            
        } else {
            if (isFriday) {
                infoHTML = `Order Now - Get it as soon <strong>${deliveryDateFormatted}</strong>`;
            } else {
                infoHTML = `Earliest available ${deliveryTextLow} date is <strong>${deliveryDateFormatted}</strong>.`;
            }
            
            if (!isTestMode) setTimeout(updateDeliveryInfo, 60000); 
        }
    }
    
    if (isFriday) {
        upsellHTML = `<div style="margin-top: 5px; font-size: 0.9em; color: #555;">
            Need it by the weekend? Saturday delivery £20 at checkout.
        </div>`;
    }

    infoElement.innerHTML = infoHTML + upsellHTML;
    
    if (result.reasons.length > 0) {
        reasonElement.innerHTML = `<strong>Note:</strong> Delivery date adjusted due to non-working days:<br>
            <ul>${result.reasons.map(reason => `<li>${reason}</li>`).join('')}</ul>`;
        reasonElement.style.display = 'none';
    } else {
        reasonElement.style.display = 'none';
    }
};

const fetchHolidays = async () => {
    try {
        const response = await fetch(BANK_HOLIDAYS_API);
        const data = await response.json();
        
        const events = data[DIVISION].events;
        
        events.forEach(event => {
            UK_HOLIDAYS_MAP[event.date] = event.title;
        });
        
        updateDeliveryInfo();
        
    } catch (error) {
        updateDeliveryInfo(); 
    }
};

fetchHolidays();